import {
  TextInput,
  RadioButtonGroupInput,
  ArrayInput,
  SimpleFormIterator,
  Edit,
  SimpleForm,
  required,
} from "react-admin";

import { CustomToolbar } from "../../../utils";

const validateRequired = required();

const SurveyEdit = (props) => (
  <Edit title="Nova Pesquisa" {...props}>
    <SimpleForm redirect="list" toolbar={<CustomToolbar />}>
      <TextInput
        label="Pergunta"
        source="question"
        validate={validateRequired}
        resettable
      />
      <RadioButtonGroupInput
        defaultValue="0"
        label="Tipo de Pesquisa"
        validate={validateRequired}
        source="typeSurvey"
        choices={[
          { id: "0", name: "Singular" },
          { id: "1", name: "Múltipla Escolha" },
        ]}
      />
      <ArrayInput
        label="Respostas"
        source="options"
        validate={validateRequired}
      >
        <SimpleFormIterator>
          <TextInput
            label="Escreva uma resposta"
            source="value"
            validate={validateRequired}
          />
        </SimpleFormIterator>
      </ArrayInput>
    </SimpleForm>
  </Edit>
);

export default SurveyEdit;
